// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfn_a"};